import clsx from 'clsx'
import React from 'react'
import styles from './index.module.css'

type props = {
  currencySymbol: React.ReactNode
  price: React.ReactNode
  period: React.ReactNode
}

/**
 * A component that displays pricing information with currency symbol, price, and optional period
 * @param currencySymbol - Currency symbol to display (default: '$')
 * @param price - Price amount to display, shows disabled styling if 0
 * @param period - Optional period text to display after the price (e.g., '/month')
 * @returns Pricing display with formatted currency, price, and period information
 */
const PricingCounter = (props: props): React.ReactNode => {
  const { currencySymbol, price, period } = props
  return (
    <div>
      <div
        className={clsx(styles.pricingCounterNum, {
          [styles.pricingCounterNumDisable]: price === 0,
        })}
      >
        {currencySymbol}

        {price}
        {period && (
          <span className={styles.pricingCounterPeriod}>{period}</span>
        )}
      </div>
    </div>
  )
}

PricingCounter.defaultProps = {
  currencySymbol: '$',
}
export default PricingCounter
